import React from 'react';
import BaseFilter from './base_filter';
import FilterSelect from '../partners/filter_select'
import {
    FILTER_OPTIONS,
    SLIDERS_DATA
} from './filter_constants_and_helpers'

class ClarityFilter extends BaseFilter {

    constructor(props) {
        super(props)

        this.options = SLIDERS_DATA.clarity.map(e => {
            return FILTER_OPTIONS.clarity.find(s => s.pretty_name === e)
        })
        Object.assign(this.state,this.stored || this._defaultValue())
        this._setDefault = this._setDefault.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
    }

    setFilters(filterName,newValue,removeFunction = this.removeFilter,firstLoad) {
        super.setFilters(filterName,{in:newValue},removeFunction, firstLoad)
    }

    removeFilter(name) {
        if ( name ) {
            this.setFilters(ClarityFilter.getFilterName(), this._dropDownRemoveFilter(name, " " + this._getFilterName()))
        } else {
            this._setDefault()
        }
    }

    /**
     * The following set of function starting with _ are 'protected' and should be called by the base class only.
     * @private
     */
    _defaultValue() {
        return {
            in: []
        }
    }

    _setDefault() {
        this.setFilters(ClarityFilter.getFilterName(),this._defaultValue().in)
    }

    _render() {
        return <div>
            <FilterSelect
                label={"Clarity"}
                name={ClarityFilter.getFilterName()}
                options={this.options}
                route={"recent_deals_"+this.props.itemType}
                selectedOptions={this.state.in}
                setFilters={this.setFilters}
                systemName={ClarityFilter.getFilterName()}
            />
        </div>
    }

    _apiValues(values) {
        return {in:this._findInterValues(values,'clarity')}
    }

    _getFilterValue() {
        return this.state.in
    }

    _getFilterName() {
        return ClarityFilter.getFilterName()
    }

    _tagName(newState) {
        let tagList = []
        for ( let id of newState.in ) {
            let option = this.options.find(e => e.id == id)
            if ( option ) tagList.push(option.pretty_name + " " + this._getFilterName())
        }
        return tagList
    }

    _apiKeys() {
        return ['in']
    }

    /**
     * static functions to be supported without an instance for generic filter usage implementations.
     * @returns {string}
     */
    static getFilterName() {
        return "clarity"
    }
}

export default ClarityFilter;